import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import GrowthSystem from "@/pages/GrowthSystem";

export const Route = createFileRoute("/contractor-growth-system")({
  component: GrowthSystem,
  head: () =>
    pageHead({
      title: "Contractor Website and Local SEO System | jaik",
      description:
        "A contractor website and local SEO system built to book high-margin jobs in King County and western Washington. Check if your business is a fit.",
      path: "/contractor-growth-system",
      noindex: true,
    }),
});
